import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.173 2H4.827a2 2 0 0 0-1.79 1.109v.001L.743 7.688A.66.66 0 0 0 .667 8v4a2 2 0 0 0 2 2h10.666a2 2 0 0 0 2-2V8a.66.66 0 0 0-.077-.312L12.964 3.11A2 2 0 0 0 11.173 2m2.414 5.333-1.816-3.628-.001-.002a.67.67 0 0 0-.597-.37H4.827a.67.67 0 0 0-.597.37l-.597-.296.597.298-1.817 3.628h2.92c.223 0 .431.112.555.297l1.136 1.703h1.953l1.135-1.703a.67.67 0 0 1 .555-.297zM2 8.667V12a.667.667 0 0 0 .667.667h10.666A.667.667 0 0 0 14 12V8.667h-2.976L9.888 10.37a.67.67 0 0 1-.555.297H6.667a.67.67 0 0 1-.555-.297L4.977 8.667z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })